import { useEffect, useState } from 'react'

/**
 * The primary pointer is a finger. Distinct from `useIsPhone`, which is about room: a desktop
 * browser made narrow is phone-sized but still driven by a mouse, and needs what a mouse needs.
 */
export const COARSE_POINTER_QUERY = '(pointer: coarse)'

export function useCoarsePointer(): boolean {
  const [coarse, setCoarse] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(COARSE_POINTER_QUERY).matches
      : false,
  )
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mq = window.matchMedia(COARSE_POINTER_QUERY)
    const handler = (e: MediaQueryListEvent) => setCoarse(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])
  return coarse
}

export default useCoarsePointer
